export default class ControlsBase {

  constructor (player, element) {
    this.player = player
    this.element = element

    this.enabled = false
  }

}
